import React, { Component } from "react";
import ApiConnect from "../../../../Utils/ApiConnect";
import { toast } from "react-toastify";
import TagsInput from "react-tagsinput";

import "react-tagsinput/react-tagsinput.css";

export default class NewCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryName: [],
      storeName: [],
      brandName: [],
      text: "",
      Fdata: [],
      tags: [],
      formError: "",
      CategoryImages: [],
      previewImage: [],
      componentsLoad: false,
      btnDisable: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  loadComponets() {
    if (!this.state.componentsLoad) {
      ApiConnect.get("/Module/Inventory/Godown/Details")
        .then((response) => {
          this.setState({
            storeName: response.data,
            componentsLoad: true,
          });
        })
        .catch((error) => console.log(error));
    }
  }
  imageHandleChange(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({
        CategoryImages: e.target.files[0],
        previewImage: fileArray,
      });
    }
  }
  handleChange(e) {
    const newData = { ...this.state.Fdata };
    newData[e.target.name] = e.target.value;
    this.setState({ Fdata: newData });
  }
  submitHandler(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    let formData = new FormData();
    formData.append("name", this.state.Fdata.name || ""); //append the values with key, value pair
    formData.append("page_title", this.state.Fdata.page_title || "");
    formData.append("slug", this.state.Fdata.slug || "");
    formData.append("godown", this.state.Fdata.godown || "");
    formData.append("webview", this.state.Fdata.webview || "");
    formData.append("tags", JSON.stringify(this.state.tags));
    formData.append("orderplace", this.state.Fdata.orderplace);
    formData.append("images_files", this.state.CategoryImages);

    ApiConnect({
      method: "post",
      url: "/Module/Inventory/Category/NewCategory",
      data: formData,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            Fdata: [],
            CategoryImages: [],
            previewImage: [],
            tags: [],
          });
        } else {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }
  handleChangeTag(tags) {
    this.setState({ tags });
  }
  render() {
    return (
      <form onSubmit={(e) => this.submitHandler(e)}>
        <p className="text-danger">{this.state.formError}</p>
        <div className="row g-3 mb-3">
          <div className="col-xl-8 col-lg-8">
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Basic information</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Oculus VR"
                      value={this.state.Fdata["name"] || ""}
                      onFocus={(e) => this.loadComponets()}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Page Title</label>
                    <input
                      type="text"
                      name="page_title"
                      value={this.state.Fdata["page_title"] || ""}
                      className="form-control"
                      placeholder="Gaming VR"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">
                      Category Identifier URL
                    </label>
                    <div className="input-group mb-3">
                      <span className="input-group-text">
                        https://YourWebsite.com/Category/
                      </span>
                      <input
                        type="text"
                        name="slug"
                        value={this.state.Fdata["slug"] || ""}
                        className="form-control"
                        placeholder="NarayaniGroup"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Category Image</label>
                    <div className="file-group">
                      <input
                        type="file"
                        id="file"
                        accept="image/*"
                        onChange={(e) => this.imageHandleChange(e)}
                      />
                      <label htmlFor="file">
                        <span className="material-icons-outlined">
                          upload_file
                        </span>
                      </label>
                    </div>
                    <div className="row">
                      {this.state.previewImage.map((image, index) => (
                        <div className="col" key={index}>
                          <img
                            className="img-thumbnail"
                            width="150"
                            src={image}
                            alt={`doc${index}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Inventory Info</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label">Godown Select</label>
                    <select
                      name="godown"
                      className="form-control"
                      value={this.state.Fdata["godown"] || ""}
                      onChange={(e) => this.handleChange(e)}
                    >
                      <option defaultValue>Select Godown</option>
                      {this.state.storeName.map((key, index) => (
                        <option value={key.godownid} key={index}>
                          {key.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Web Visibility Status</label>
                    <select
                      name="webview"
                      className="form-control"
                      value={this.state.Fdata["webview"] || ""}
                      onChange={(e) => this.handleChange(e)}
                    >
                      <option defaultValue>Web Visibility</option>
                      <option value="1" defaultValue>
                        Published
                      </option>
                      <option value="0">Scheduled</option>
                      <option value="0">hidden</option>
                    </select>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Order place</label>
                    <div className="custom-radio row">
                      <label className="col-6">
                        <input
                          type="radio"
                          name="orderplace"
                          value="kitchen"
                          onChange={(e) => this.handleChange(e)}
                          required="required"
                        />
                        <div className="box">
                          <span className="material-icons-outlined">
                            kitchen
                          </span>
                          <br />
                          Kitchen
                        </div>
                      </label>
                      <label className="col-6">
                        <input
                          type="radio"
                          name="orderplace"
                          value="bar"
                          onChange={(e) => this.handleChange(e)}
                          required="required"
                        />
                        <div className="box">
                          <span className="material-icons-outlined">
                            local_bar
                          </span>
                          <br /> Bar
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Tags</label>
                    <TagsInput
                      value={this.state.tags}
                      onChange={(e) => this.handleChangeTag(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="card-footer flexbox flex-justified text-center">
          <button
            className="btn btn-success text-white fw-500"
            disabled={this.state.btnDisable}
          >
            Save
          </button>
        </footer>
      </form>
    );
  }
}
